import { Component, OnInit, ViewChild } from '@angular/core';
import { UtenteModalComponent } from '../utente-modal/utente-modal.component';
import { DialogService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { AlertUtil } from '../utils/alert-util';
import * as Enum from '../utils/enums'
import * as Constants from '../utils/constants';
import { Loading } from '../utils/loading';
import { RequestBuilder } from '../classes/request-builder';
import { finalize } from 'rxjs/operators';
import { UtenteService } from '../services/utente.service';
import { DataTableComponent } from '../data-table/data-table.component';
import { IUtente } from '../interfaces/IUtente';

@Component({
  selector: 'app-utente',
  templateUrl: './utente.component.html',
  styleUrls: ['./utente.component.css']
})
export class UtenteComponent implements OnInit {

  //Variabili
  isAdmin: boolean
  disableUtenteTooltip: boolean

  utenti: IUtente[]
  DTT = Enum.DATA_TABLE_TYPE_ENUM //export enum for html

  payloadUtente: any

  @ViewChild("dtUtenti") dtUtenti: DataTableComponent

  constructor(private dialogService: DialogService, private translate: TranslateService, private alertUtil: AlertUtil,
    private utenteService: UtenteService) {
    let userRole = localStorage.getItem(Constants.LS_USER_ROLE)
    this.checkUserRole(userRole)
  }

  ngOnInit() {
    setTimeout(() => {
      this.getAllUtenti()
    }, 0);
  }

  /**
  * check role of user logged
  */
  checkUserRole(userRole: string) {
    if (userRole == Enum.USER_TYPE_ENUM.AMMINISTRATORE) {
      this.disableUtenteTooltip = true
      this.isAdmin = true;
    } else {
      this.disableUtenteTooltip = false
      this.isAdmin = false;
    }
  }

  openUtenteModal(utente?: IUtente) {
    //get header translation
    this.translate.get(["LBL_NEW_UTENTE", "LBL_UPDATE_UTENTE"]).subscribe(res => {
      //open gruppo modal
      let utenteModal = this.dialogService.open(UtenteModalComponent, {
        data: {
          utente: utente
        },
        header: utente ? res["LBL_UPDATE_UTENTE"] : res["LBL_NEW_UTENTE"],
        width: '50%'
      })

      // refresh commesse when modal is closed and newUtente is created
      utenteModal.onClose.subscribe((newUtente) => {
        if (newUtente) {
          this.getAllUtenti()
        }
      })
    })
  }

  /**
   * delete object confirmation
   */
  openDeleteDialog(utenteObj: IUtente) {
    this.alertUtil.showConfirmationAlert("LBL_CONFIRM_UTENTE_DELETE", null, null, null, null, () => {
      this.deleteUtente(utenteObj)
    });
  }

  /**
   * fetch all gruppi for table
   */
  getAllUtenti() {
    this.setPayloadUtente()
    Loading.isLoading = true
    let reqBuilder = new RequestBuilder(this.payloadUtente)
    this.utenteService.getUtenti(reqBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response.data) {
          this.dtUtenti.resetTable()
          this.utenti = response.data
          this.getGruppiAssociatiFromResponse()
        }
        else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }

  deleteUtente(utenteObj: IUtente) {
    Loading.isLoading = true
    let payload = {
      UserID: utenteObj.UserId
    }
    let reqBuilder = new RequestBuilder(payload)
    this.utenteService.deleteUtente(reqBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response.data) {
          //MESSAGGIO OK 
          this.alertUtil.showAlert("LBL_DELETE_UTENTE_SUCCESS", null, null, null, () => {
            this.getAllUtenti()
          })
        }
        else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }

  /**
   * set payload for API
   */
  setPayloadUtente() {
    this.payloadUtente = {
      ApplicationName: "/"
    }
  }

  /**
  * get gruppi associati all'utente
  */
  getGruppiAssociatiFromResponse() {
    let gruppiString = " "
    for (let i = 0; i < this.utenti.length; i++) {//ciclo gli utenti
      let utente = this.utenti[i]
      if (utente.Gruppi) {
        if (utente.Gruppi.length == 0) { //Controllo se Gruppi è valorizzato
          gruppiString = "Nessun gruppo associato"
          utente.GruppiAssociati = gruppiString  // associo la stringa al campo GruppiAssociati
          gruppiString = ""
        } else {
          for (let y = 0; y < utente.Gruppi.length; y++) { // ciclo gruppi
            let gruppo = utente.Gruppi[y]
            gruppiString += gruppo.Nome + "," //costruisco la stringa dei gruppi associati
          }
          gruppiString = gruppiString.slice(0, -1); // rimuovo l'ultima virgola
          utente.GruppiAssociati = gruppiString  // associo la stringa al campo GruppiAssociati
          gruppiString = ""
        }
      }
    }
  }
}
